import { render, staticRenderFns } from "./VerificationBanner.vue?vue&type=template&id=e896e570&scoped=true&"
import script from "./VerificationBanner.vue?vue&type=script&lang=js&"
export * from "./VerificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./VerificationBanner.vue?vue&type=style&index=0&id=e896e570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e896e570",
  null
  
)

export default component.exports